/**
 * @generated SignedSource<<aaa127a8a1ad79133c00d21667fb7c15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ShareholderUpsertInputObject = {
  handle: string;
  name?: string | null | undefined;
  notes?: string | null | undefined;
  ordinal?: number | null | undefined;
  stakeholderCxid?: string | null | undefined;
};
export type dividendsPage_ShareholderMutation$variables = {
  input: ShareholderUpsertInputObject;
};
export type dividendsPage_ShareholderMutation$data = {
  readonly shareholderUpsert: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly shareholder: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type dividendsPage_ShareholderMutation = {
  response: dividendsPage_ShareholderMutation$data;
  variables: dividendsPage_ShareholderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Shareholder",
  "kind": "LinkedField",
  "name": "shareholder",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "dividendsPage_ShareholderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ShareholderUpsertMutationPayload",
        "kind": "LinkedField",
        "name": "shareholderUpsert",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "dividendsPage_ShareholderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ShareholderUpsertMutationPayload",
        "kind": "LinkedField",
        "name": "shareholderUpsert",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "837512f1f369650de380370ec3e54cb9",
    "id": null,
    "metadata": {},
    "name": "dividendsPage_ShareholderMutation",
    "operationKind": "mutation",
    "text": "mutation dividendsPage_ShareholderMutation(\n  $input: ShareholderUpsertInputObject!\n) {\n  shareholderUpsert(input: $input) {\n    shareholder {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fc6215d862dad6a644f902a537c2df3d";

export default node;
